module.exports = __webpack_public_path__ + "static/composition-fractal-31dd6b7bbb20d17d0a2e538012e297f3.png";